module.exports = __webpack_public_path__ + "media/images/views/lp/client/choose-sourcedout/client-benefit-03-0a0e4da817770b12fa16b382a959f407.png";